/**
 * 
 * this is ready-to-paste POC for a codesandbox
 * 
 * --- Idea ---
 * if a function is called concurrently
 * (multiple calls in parallel)
 * place all in a queue
 * and when the 1st one returns,
 * all will return the same result without needing to execute the subsequent ones
 * (it's similar to debouncing but is not based on time but rather stacks)
 * => beware we don't take into account parameters of the function call here
 *      so it's basically for functions without params (ex: sync(), refresh(), update_val()...)
 *
 * 
 * --- why ? ----------------------
 * I used to use complex Promises with resolve() and reject() and settimeouts
 * to check when the value was updated, and it creates a ton of loops in parallels
 * which is very inefficient. But this solution using a queue has proven MUCH efficient
 * (tested with 300 parallels calls and it performed awesome)
 * and is much easier to understand / read / shorter.
 * 
 */

import delay from "delay";
import PQueue from "p-queue";
import { getLog } from "../helpers/helpers";

async function _compute() {
  // takes 2 seconds to answer
  await delay(2000);
  return "my result";
}
// we should only need to override a function
// like this to turn it into a wait&return-debounced function
// could be turned into a decorator
// or an array of functions & a loop that would apply this to all functions in a class
const compute = async (...args) => { return await waitIfConcurrentAndReturnRes(_compute, ...args) }
// func.call allows us to pass the context (if you need 'this')
// const compute = async (...args) => { return await waitIfConcurrentAndReturnRes.call(this, _compute, ...args) }




const allQueues = {};
const allQueuesRes = {};

/** if a function is called concurrently (multiple calls in parallel)
 * all but the first one will be placed in a queue and when the 1st one returns,
 * all will return the same result (similar to debouncing) 
 */
// TODO we should also save args in fname ? or a hash of them ?
export async function waitIfConcurrentAndReturnRes(func, ...args) {
  const fname = func.name
  const log = getLog("waitIfConcurrentAndReturnRes(" + fname + "):")

  const queueExists = !!allQueues[fname]
  if (!queueExists) {
    log("creating queue")
    allQueues[fname] = new PQueue({ concurrency: 1 })
  }

  let queue = allQueues[fname]
  const i_stack = queue.pending + queue.size
  if (i_stack === 0) {
    log("firstCall detected")
    let res = await queue.add(async () => {
      // let res = await func(...args)
      let res = await func.call(this, ...args)  // func.call allows us to pass the context
      if (!allQueuesRes[fname]) allQueuesRes[fname] = { res: res }
      else allQueuesRes[fname].res = res
      return res
    })
    log("firstCall resolving with res=", res)
    return res
  }
  else {
    log("stackedCall detected", i_stack)  // " Size:",queue.size,"  Pending:",queue.pending
    let res = await queue.add(async () => { return allQueuesRes[fname].res })
    log("stackedCall", i_stack, "resolving with res=", res)
    return res
  }
}



async function f2(start, i) {
  const res = await compute();
  const elapsed = Date.now() - start;
  console.log("res for call", i, "=", res, "in", elapsed, "ms")
}

async function f() {
  console.log("---");
  const start = Date.now();
  let promises = [];
  for (let i = 0; i < 3; i++) {
    promises.push(f2(start, i))
  }
  await Promise.all(promises)
  console.log("--- all is over ---")
}
//f(); // uncomment to test
